import classNames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Button,
  Loader,
  Switch,
} from 'components';

import Input from 'bgr-react-input';

import { downloadFile, getRootUrl } from 'services/api';
import filename from 'utils/filename';

export default class SystemsDetailShare extends Component {

  /* Lifecycle */

  constructor(props) {
    super(props);

    this.DOWNLOADS = [
      {
        label: 'quote',
        fileTypeLabel: 'quote',
        extension: 'pdf',
        url: `quote?locale=${props.intl.locale}&show-prices=true`,
        type: 'application/pdf',
      }, {
        label: 'systemSketch',
        fileTypeLabel: 'systemSketch',
        extension: 'png',
        url: 'sketch',
        type: 'image/png',
      }, {
        label: 'billMaterials',
        fileTypeLabel: 'billMaterials',
        extension: 'xls',
        url: 'bom',
        type: 'application/xls',
      },
    ];

    const state = {
      add_message: true,
      add_manual: false,
      bill_materials: true,
      default_message: props.intl.messages['systems.share.defaultMessage'],
      disabled: true,
      edit_subject: true,
      email: '',
      loaders: {},
      subject: props.intl.messages['systems.quote.title'],
      system_sketch: true,
      sent: false,
    };

    this.DOWNLOADS.forEach((item) => {
      state.loaders[item.label] = false;
    });

    this.state = {
      ...state,
    };

    this.onSend = this.onSend.bind(this);
  }

  componentWillMount() {
    if (!this.props.project.data) {
      this.props.projectGet(this.props.params.projectId);
    }
  }

  /* Handlers */

  onChange(value, name) {
    this.setState({
      [name]: value,
    });
  }

  onExport({ label, fileTypeLabel, extension, type, url }) {
    const {
      intl: { messages },
      project: {
        data: { id, attributes: { name, sequence_number } },
      },
    } = this.props;

    this.setState({ loaders: { ...this.state.loaders, [label]: true } }, () => {
      // TODO Translations as filename
      const exportedFileName = filename(name, extension, [
        sequence_number,
        moment().format('DDMMYY'),
        messages[`systems.share.${fileTypeLabel}`].toUpperCase(),
      ]);

      if (type === 'application/pdf') {
        this.props.projectExport(id, url, exportedFileName.slice(0, -4), label).then((response) => {
          downloadFile(response.url);
          this.setState({ loaders: { ...this.state.loaders, [label]: false } });
        });
      } else {
        downloadFile(`${getRootUrl()}/api/projects/${id}/${url}`);
        this.setState({ loaders: { ...this.state.loaders, [label]: false } });
      }
    });
  }

  onSend() {
    const { params: { projectId }, projectShare } = this.props;
    const {
      add_manual,
      bill_materials,
      default_message,
      email,
      subject,
      system_sketch,
      add_message,
    } = this.state;

    // TODO This POST data will vary
    const data = {
      add_manual,
      bill_materials,
      default_message,
      quote: true,
      send_duplicate: false,
      show_prices: true,
      subject,
      system_sketch,
      add_message,
    };

    // Check for multiple e-mails
    const emailsSemicolon = email.split(';').map(str => str.trim());
    const emailsComma = email.split(',').map(str => str.trim());

    if (emailsSemicolon.length > 1) {
      data.emails = emailsSemicolon;
    } else if (emailsComma.length > 1) {
      data.emails = emailsSemicolon;
    } else {
      data.email = email;
    }

    data.locale = this.props.intl.locale;

    this.setState({
      sent: false,
    });

    projectShare(projectId, { data }).then(() => {
      this.setState({
        sent: true,
      });
    }).catch(() => {
      this.setState({
        sent: true,
      });
    });
  }

  onSubjectChange(value, name) {
    if (value.length <= 50) {
      this.setState({
        [name]: value,
      });
    }
  }

  /* Render */

  render() {
    return (
      <div className="view__content share">
        <div className="container">
          <div className="row">
            <div className="gr-6">{this.renderExportPanel()}</div>
            <div className="gr-6">{this.renderSharePanel()}</div>
          </div>
        </div>
      </div>
    );
  }

  renderExportPanel() {
    let loading = false;

    const { project } = this.props;

    const manuals = (project && project.data && project.data.attributes) ?
      this.props.project.data.attributes.manuals
      :
      [];

    const list = this.DOWNLOADS.map((item) => {
      const itemClasses = classNames('share__list-item', {
        'is-loading': this.state.loaders[item.label],
      });

      if (!loading && this.state.loaders[item.label]) {
        loading = true;
      }

      return (
        <li key={item.label} className={itemClasses}>
          <Button
            className="button share__list-item__button"
            disabled={this.state.loaders[item.label]}
            onClick={() => this.onExport(item)}
          >
            <div className="align align--fluid align--gutter-sm">
              <div className="align__cell">
                <FormattedMessage id={`systems.share.${item.label}`} />
              </div>
              <div className="align__cell align__cell--shrink u-pos-relative">
                <div className="share__list-item__cta">
                  {item.extension.toUpperCase()}
                </div>
                <div className="share__list-item__loader">
                  <Loader size="sm" visible />
                </div>
              </div>
            </div>
          </Button>
        </li>
      );
    });

    return (
      <div className="share__panel share__panel--transparent">
        <div className="offset">
          <div className="share__title">
            <div className="align align--fluid align--gutter-sm">
              <div className="align__cell align__cell--shrink">
                <span className="icon icon-save-cloud icon--lg" />
              </div>
              <div className="align__cell">
                <FormattedMessage id="systems.share.download" />
              </div>
            </div>
          </div>
        </div>
        <div className="offset offset--lg">
          <ul className="share__list">
            {list}
            {manuals.map(manual => (
              <li key={manual.url} className="share__list-item">
                <a
                  className="button share__list-item__button"
                  href={manual.url}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <div className="align align--fluid align--gutter-sm">
                    <div className="align__cell button__content">
                      <FormattedMessage id={'systems.share.manual'} />
                    </div>
                    <div className="align__cell align__cell--shrink u-pos-relative">
                      <div className="share__list-item__cta">
                        PDF
                      </div>
                    </div>
                  </div>
                </a>
              </li>))
              }
          </ul>
        </div>
      </div>
    );
  }

  renderSharePanel() {
    const {
      add_manual,
      add_message,
      bill_materials,
      default_message,
      edit_subject,
      email,
      subject,
      system_sketch,
      sent,
    } = this.state;

    const { intl, project, share } = this.props;

    const manuals = (project && project.data && project.data.attributes) ?
      this.props.project.data.attributes.manuals
      :
      [];

    const disabled = share.loading || project.put.loading;

    let message = null;

    if (sent) {
      if (share.error) {
        message = (<span className="u-color-state-danger"><FormattedMessage id="systems.share.failure" /></span>);
      } else {
        message = (<span className="u-color-state-success"><FormattedMessage id="systems.share.success" /></span>);
      }
    }

    return (
      <div className="share__panel">
        <div className="offset">
          <div className="share__title">
            <div className="align align--fluid align--gutter-sm">
              <div className="align__cell align__cell--shrink">
                <span className="icon icon-export icon--lg" />
              </div>
              <div className="align__cell">
                <FormattedMessage id="systems.share.shareViaMail" />
              </div>
              <div className="align__cell align__cell--shrink">
                <Loader size="md" visible={disabled} />
              </div>
            </div>
          </div>
        </div>

        {/* Email address */}
        <div className="offset offset--lg share__field">
          <Input
            hideLabel
            name="email"
            type="email"
            disabled={disabled}
            onChange={value => this.onChange(value, 'email')}
            placeholder={intl.messages['systems.share.emailPlaceholder']}
            required
            validate
            value={email}
          />
        </div>

        {/* Sketch */}
        <div className="offset offset--md offset--divider">
          <Switch
            disabled={disabled}
            label="systems.share.systemSketch"
            onChange={evt => this.onChange(evt, 'system_sketch')}
            value={system_sketch}
          />
        </div>

        {/* Manual */}
        {manuals.length > 0 &&
          <div className="offset offset--md offset--divider">
            <Switch
              disabled={disabled}
              label="systems.share.addManual"
              onChange={evt => this.onChange(evt, 'add_manual')}
              value={add_manual}
            />
          </div>
        }

        {/* Bill of material */}
        <div className="offset offset--md offset--divider">
          <Switch
            disabled={disabled}
            label="systems.share.billMaterials"
            onChange={evt => this.onChange(evt, 'bill_materials')}
            value={bill_materials}
          />
        </div>

        {/* Edit subject */}
        <div className="offset offset--md offset--divider">
          <Switch
            disabled={disabled}
            label="systems.share.editSubject"
            onChange={evt => this.onChange(evt, 'edit_subject')}
            value={edit_subject}
          />
        </div>
        <div className="offset offset--sm">
          <Input
            hideLabel
            name="subject"
            disabled={disabled || !edit_subject}
            onChange={value => this.onSubjectChange(value, 'subject')}
            required={false}
            placeholder={intl.messages['systems.share.editSubjectPlaceholder']}
            validate={false}
            value={subject}
          />
          <span className="u-text-small is-transparent">
            <FormattedMessage id="general.validation.maxCharacters" values={{ amount: 50 }} />
          </span>
        </div>

        {/* Add message */}
        <div className="offset offset--md offset--divider">
          <Switch
            disabled={disabled}
            label="systems.share.addMessage"
            onChange={evt => this.onChange(evt, 'add_message')}
            value={add_message}
          />
        </div>
        <div className="offset offset--sm">
          <Input
            hideLabel
            name="default_message"
            type="textarea"
            disabled={disabled || !add_message}
            onChange={value => this.onChange(value, 'default_message')}
            required={false}
            validate={false}
            value={default_message}
          />
        </div>

        {/* Send */}
        <div className="offset offset--lg">
          <div className="align align--fluid align--gutter-sm">
            <div className="align__cell align__cell--shrink">
              <Button className="button button-bg-yellow button-regular modal__button-action" onClick={this.onSend} loading={disabled} disabled={disabled || !email.length}>
                <FormattedMessage id="actions.send" />
              </Button>
            </div>
            <div className="align__cell">
              {message}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderSelectArrow(params) {
    const iconClassNames = classNames('icon', 'icon--xxs', {
      'icon-chevron-up': params.isOpen,
      'icon-chevron-down': !params.isOpen,
    });

    return (
      <span className={iconClassNames} />
    );
  }
}

SystemsDetailShare.propTypes = {
  intl: PropTypes.object,
  params: PropTypes.object,
  project: PropTypes.object,
  projectExport: PropTypes.func,
  projectGet: PropTypes.func,
  projectShare: PropTypes.func,
  share: PropTypes.object,
};



// WEBPACK FOOTER //
// ./js/views/systems/detail/share/index.jsx